import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Sun } from 'lucide-react';
import { useAuth } from '../App';
import { toast } from 'sonner';
import MultiStepRegister from '../components/MultiStepRegister';

const RegisterPage = () => {
    const navigate = useNavigate();
    const { register } = useAuth();
    const [loading, setLoading] = useState(false);

    const handleComplete = async (formData) => {
        setLoading(true);
        try {
            // Register user with basic details
            await register(formData.name, formData.email, formData.password, formData.phone);

            // Save additional user data to localStorage (will be synced with backend later)
            const userData = {
                name: formData.name,
                email: formData.email,
                phone: formData.phone,
                address: formData.address,
                solarInfo: formData.solarInfo,
                billingAddress: formData.billingAddress,
                gstNumber: formData.gstNumber,
                preferredPaymentMethod: formData.preferredPaymentMethod
            };

            localStorage.setItem('user_profile_data', JSON.stringify(userData));

            toast.success('Account created successfully! Welcome to SolarSavers!');
            navigate('/');
        } catch (error) {
            toast.error(error.response?.data?.detail || 'Registration failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen md:pt-20 flex items-center justify-center py-12 px-4 -mt-14 pt-14 md:mt-0">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="w-full max-w-3xl"
            >
                <div className="text-center mb-8">
                    <Link to="/" className="inline-flex items-center gap-2 mb-6">
                        <Sun className="w-10 h-10 text-primary" />
                        <span className="text-2xl font-bold">
                            <span className="solar-text-gradient">Solar</span>Savers
                        </span>
                    </Link>
                    <h1 className="text-3xl font-bold">Create Your Account</h1>
                    <p className="text-muted-foreground mt-2">
                        Join SolarSavers and start your journey to sustainable energy
                    </p>
                </div>

                {loading ? (
                    <div className="bg-card rounded-2xl border p-12 text-center">
                        <div className="animate-spin w-12 h-12 border-4 border-primary border-t-transparent rounded-full mx-auto mb-4" />
                        <p className="text-muted-foreground">Creating your account...</p>
                    </div>
                ) : (
                    <MultiStepRegister onComplete={handleComplete} />
                )}

                <div className="mt-6 text-center text-sm">
                    <span className="text-muted-foreground">Already have an account? </span>
                    <Link to="/login" className="text-primary font-medium hover:underline">
                        Sign in
                    </Link>
                </div>
            </motion.div>
        </div>
    );
};

export default RegisterPage;
